import styled from "styled-components";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  flex: 1;
`

export default Content